"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Plugin;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Plugin = class Plugin {
    static async get(pluginId, ncMeta = _Noco.default.ncMeta) {
        let plugin = pluginId && await _NocoCache.default.get('root', `${_globals.CacheScope.PLUGIN}:${pluginId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!plugin) {
            plugin = await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, pluginId);
            await _NocoCache.default.set('root', `${_globals.CacheScope.PLUGIN}:${pluginId}`, plugin);
        }
        return plugin && new Plugin(plugin);
    }
    static async list(ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList('root', _globals.CacheScope.PLUGIN, []);
        let { list: pluginList } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !pluginList.length) {
            pluginList = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN);
            await _NocoCache.default.setList('root', _globals.CacheScope.PLUGIN, [], pluginList);
        }
        return pluginList;
    }
    static async count(ncMeta = _Noco.default.ncMeta) {
        var _this;
        return (_this = await ncMeta.knex(_globals.MetaTable.PLUGIN).count('id', {
            as: 'count'
        })) == null ? void 0 : _this.count;
    }
    static async update(pluginId, plugin) {
        const updateObj = (0, _extractProps.extractProps)(plugin, [
            'input',
            'active'
        ]);
        if (updateObj.input && typeof updateObj.input === 'object') {
            updateObj.input = JSON.stringify(updateObj.input);
        }
        // set meta
        await _Noco.default.ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, updateObj, pluginId);
        await _NocoCache.default.update('root', `${_globals.CacheScope.PLUGIN}:${pluginId}`, updateObj);
        return this.get(pluginId);
    }
    static async isPluginActive(id, ncMeta = _Noco.default.ncMeta) {
        var _this;
        return !!((_this = await this.getPlugin(id, ncMeta) || await this.getPluginByTitle(id, ncMeta)) == null ? void 0 : _this.active);
    }
    /**
   * get plugin by id
   */ static async getPlugin(id, ncMeta = _Noco.default.ncMeta) {
        let plugin = id && await _NocoCache.default.get('root', `${_globals.CacheScope.PLUGIN}:${id}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!plugin) {
            plugin = await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, id);
            await _NocoCache.default.set('root', `${_globals.CacheScope.PLUGIN}:${id}`, plugin);
        }
        return plugin;
    }
    // keeping it for backward compatibility, if someone configured google auth via plugin it still relies on this
    static async getPluginByTitle(title, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, {
            title
        });
    }
    constructor(audit){
        Object.assign(this, audit);
    }
};
